module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "text-bold",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.profile.prompt')))]), _vm._v(" "), _c('div', {
    staticClass: "k6-box",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "k6-profile-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.profile.profilePhoto,
      "alt": "Profile image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "k6-profile-data"
  }, [_c('div', {
    staticClass: "segment"
  }, [_c('span', [_vm._v("@" + _vm._s(_vm.profile.username))]), _vm._v(" "), _c('h3', {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.profile.firstName) + " " + _vm._s(_vm.profile.lastName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.profile.role))])]), _vm._v(" "), _c('div', {
    staticClass: "segment segment-grid"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("pages.profile.email")) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "segment-data"
  }, [_vm._v(_vm._s(_vm.profile.email))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("pages.profile.studentId")) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "segment-data"
  }, [_vm._v(_vm._s(_vm.profile.studentId))])])]), _vm._v(" "), _c('div', {
    staticClass: "k6-profile-actions"
  }, [_c('button', {
    staticClass: "btn btn-success k6-btn",
    staticStyle: {
      "border-radius": "30px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToEdit()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("pages.profile.edit")) + " "), _c('i', {
    staticClass: "fa fa-pencil",
    staticStyle: {
      "margin-left": "10px"
    }
  })])])]), _vm._v(" "), (_vm.rolesSelected && _vm.rolesSelected.length == 0) ? _c('div', {
    staticClass: "k6-profile-cards"
  }, _vm._l((_vm.groupList.myGroups.filter(function (g) { return !g.isPending; })), function(group) {
    return _c('div', {
      staticClass: "k6-profile-card",
      class: [group.groupColor !== null ? group.groupColor : _vm.defaultGColor],
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.goToGroup(group)
        }
      }
    }, [_c('div', {
      staticClass: "card-data"
    }, [_c('h2', {
      staticClass: "card-title"
    }, [_vm._v(_vm._s(_vm._f("pickTranslation")(group.groupName)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("pickTranslation")(group.groupDescription)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(group.yearName))])]), _vm._v(" "), _vm._m(0, true)])
  }), 0) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": "30px"
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-68f24edb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68f24edb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/Profile.vue
// module id = 1409
// module chunks = 1